// Facebook Event Names
export enum FbEventName {
  ADD_PAYMENT_INFO = 'AddPaymentInfo',
  ADD_TO_CART = 'AddToCart',
  ADD_TO_WISHLIST = 'AddToWishlist',
  COMPLETE_REGISTRATION = 'CompleteRegistration',
  CONTACT = 'Contact',
  CUSTOM = 'Custom Event',
  CUSTOMIZE_PRODUCT = 'CustomizeProduct',
  DONATE = 'Donate',
  FIND_LOCATION = 'FindLocation',
  INITIATE_CHECKOUT = 'InitiateCheckout',
  LEAD = 'Lead',
  PAGE_VIEW = 'PageView',
  PURCHASE = 'Purchase',
  SCHEDULE = 'Schedule',
  SEARCH = 'Search',
  START_TRIAL = 'StartTrial',
  SUBMIT_APPLICATION = 'SubmitApplication',
  SUBSCRIBE = 'Subscribe',
  VIEW_CONTENT = 'ViewContent',
}
// Facebook User Data
export type FbUserData = {
  country: string[] | string;
  ct: string[] | string;
  db: string[] | string;
  em: string[] | string;
  external_id: string[] | string;
  fn: string[] | string;
  ge: string[] | string;
  ln: string[] | string;
  ph: string[] | string;
  st: string[] | string;
  zp: string[] | string;
};

// Facebook Custom Data
export type FbCustomData = {
  [key: string]: any; // Allow for additional custom properties
  content_category?: string;
  content_ids?: string[] | string;
  content_name?: string;
  content_type?: string;
  contents?:
    | {
        id: string;
        quantity: number;
      }[]
    | string;
  currency?: string;
  num_items?: number;
  order_id?: string;
  value?: number;
};

export type FbBaseEvent = {
  a: string;
  cdl: string;
  cs_est: boolean;
  dl: string;
  dpo: any;
  ec: number;
  eid: string;
  ev: FbEventName;
  eventId: string;
  fbc?: string;
  fbp?: string;
  id: string;
  it: number;
  o: number;
  r: string;
  rl: string;
  rqm: string;
  sh: number;
  sw: number;
  ts: number;
};

// Facebook Event
export type FbEvent = FbBaseEvent & {
  customData: FbCustomData;
  userData: FbUserData;
};

// Facebook Pixel Configuration
export type FbPixelConfig = {
  pixelId: string;
};

// Facebook Conversion API Configuration
export type FbConversionApiConfig = {
  accessToken: string;
  apiVersion: string;
};

// Combined Facebook Configuration
export type FacebookConfig = {
  conversionApi?: FbConversionApiConfig;
  pixel: FbPixelConfig;
};
